import React, { useEffect, useState } from "react";
import Breadcrumb from "../../../components/common/BreadCrumb";
import Action from "../../../components/common/Action";
import { SortDownArrow } from "../../../assets/svg";
import CustomTable from "../../../components/customTable/CustomTable";
import DebounceSearch from "../../../components/common/DebounceSearch";
import ReactSelect from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { getServiceReportList } from "../../../redux/service/slice";
import RippleLoader from "../../../components/RippleLoader/RippleLoader";
import ViewServiceReport from "./ViewServiceReport";
import { getOutlet } from "../../../redux/companies/slice";

const ServiceReport = () => {
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState("");
  const [pageLimit, setPageLimit] = useState(10);
  const [pageCount, setPageCount] = useState(1);
  const [sortBy, setSortBy] = useState("");
  const [sortDirection, setSortDirection] = useState("desc");
  const [isModal, setIsModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedSaleId, setSelectedSaleId] = useState(null);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [serviceCount, setServiceCount] = useState("");
  const [selectedAction, setSelectedAction] = useState(null);
  const [showSend, setShowSend] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [outletFilter, setOutletFilter] = useState(null);
  const [selectedType, setSelectedType] = useState("");

  // selector
  const { ServiceReportList, ServiceReportListLoading, outletList } =
    useSelector((store) => ({
      ServiceReportList:
        store?.serviceData?.getServiceReportListStatus?.data?.data,
      ServiceReportListLoading: store?.serviceData?.loading,
      outletList: store?.companiesData?.getOutletStatus?.data?.data,
    }));

  //Get getServiceReportList List
  useEffect(() => {
    dispatch(
      getServiceReportList({
        search: searchValue,
        pageCount: pageCount,
        pageLimit: pageLimit,
        sort_by: sortBy,
        sort_direction: sortDirection === "asc" ? "asc" : "desc",
        outlet: outletFilter?.value || "",
        types: selectedType?.value || "",
      })
    );
    setSelectedAction("");
    setServiceCount("");
    setSelectedRows([]);
  }, [
    dispatch,
    searchValue,
    pageCount,
    pageLimit,
    sortBy,
    sortDirection,
    outletFilter,
    selectedType,
    selectedAction,
    serviceCount,
  ]);

  useEffect(() => {
    dispatch(
      getOutlet({
        search: "",
        pageCount: "",
        pageLimit: "all",
        company_id: "",
        sort_by: "name",
        sort_direction: "asc",
        outlet: "",
        manager: "",
        status: "",
      })
    );
  }, []);

  const outletOptions = Array.isArray(outletList)
    ? outletList.map((outlet) => ({
        label: outlet?.name,
        value: outlet?.id,
      }))
    : [];

  const handleRowSelection = (id, isChecked) => {
    setSelectedRows((prevSelected) => {
      let updatedSelection;

      if (isChecked) {
        updatedSelection = [...prevSelected, id];
      } else {
        updatedSelection = prevSelected.filter((rowId) => rowId !== id);
        setSelectedAction("");
        setServiceCount("");
        setSelectedRows([]);
      }

      // Update isSelectAll state
      setIsSelectAll(
        updatedSelection.length === ServiceReportList?.data?.length
      );

      return updatedSelection;
    });
  };

  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    setIsSelectAll(checked);

    if (checked) {
      setSelectedRows(ServiceReportList?.data?.map((item) => item));
    } else {
      setSelectedRows([]);
      setSelectedAction("");
      setServiceCount("");
      setSelectedRows([]);
    }
  };

  const bulkOptions = () => {
    return [
      { id: 2, value: "view report", label: "View" },
      { id: 1, value: "download", label: "Download" },
    ];
  };

  const handleBulkAction = (e) => {
    setSelectedAction(e);

    const selectedIds = selectedRows.map((row) => row.id);

    const selectedData = ServiceReportList?.data?.filter((item) =>
      selectedIds.includes(item.id)
    );

    if (!selectedData || selectedData.length === 0) return;

    if (e?.value === "download" || e?.value === "view report") {
      const uniqueCompanies = [
        ...new Set(selectedData.map((item) => item?.company_id)),
      ];

      if (uniqueCompanies.length === 1) {
        setShowSend("bulk");
        setSelectedSaleId(selectedIds);
        setIsModal(true);
      } else {
        setShowErrorPopup(true);
      }
    }
  };

  const Type = [
    { id: 1, value: "repair", label: "Repair" },
    { id: 2, value: "follow up repair", label: "Follow Up Repair" },
    { id: 3, value: "servicing", label: "Servicing" },
  ];

  const ColumnHeaders = () => (
    <>
      <th
        scope="col"
        className="p-2 font-Proxima sm:text-sm text-xs font-normal py-4 px-4 text-mgrey text-start"
      >
        <div className="flex items-center">
          <div className="flex items-center">
            <input
              type="checkbox"
              className="w-4 h-4 mr-2 accent-themeBtn"
              checked={isSelectAll}
              onChange={handleSelectAll}
            />{" "}
            <div
              className="flex items-center"
              onClick={() => {
                setSortBy("id");
                setSortDirection(sortDirection === "desc" ? "asc" : "desc");
              }}
            >
              <span>No.</span>

              <SortDownArrow
                className={`ml-1 transition-transform duration-300 ${
                  sortDirection === "asc" && sortBy === "id" ? "rotate-180" : ""
                }`}
              />
            </div>
          </div>
        </div>
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima sm:text-sm text-xs font-normal py-4 px-4 text-mgrey text-start"
      >
        <div
          className="flex items-center"
          onClick={() => {
            setSortBy("outlet");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span>Outlet</span>
          <SortDownArrow
            className={`ml-1 transition-transform duration-300 ${
              sortDirection === "asc" && sortBy === "outlet" ? "rotate-180" : ""
            }`}
          />
        </div>
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima sm:text-sm text-xs font-normal py-4 px-4 text-mgrey text-start"
      >
        <div
          className="flex items-center"
          onClick={() => {
            setSortBy("address");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span>Address</span>
          <SortDownArrow
            className={`ml-1 transition-transform duration-300 ${
              sortDirection === "asc" && sortBy === "address"
                ? "rotate-180"
                : ""
            }`}
          />
        </div>
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima sm:text-sm text-xs font-normal py-4 px-4 text-mgrey text-start"
      >
        <div
          className="flex items-center"
          onClick={() => {
            setSortBy("date_time");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span>Date & Time</span>
          <SortDownArrow
            className={`ml-1 transition-transform duration-300 ${
              sortDirection === "asc" && sortBy === "date_time"
                ? "rotate-180"
                : ""
            }`}
          />
        </div>
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima sm:text-sm text-xs font-normal py-4 px-4 text-mgrey text-start"
      >
        <div
          className="flex items-center"
          onClick={() => {
            setSortBy("technician");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span>Technician</span>
          <SortDownArrow
            className={`ml-1 transition-transform duration-300 ${
              sortDirection === "asc" && sortBy === "technician"
                ? "rotate-180"
                : ""
            }`}
          />
        </div>
      </th>
      <th className="p-2 font-Proxima sm:text-sm text-xs font-normal py-4 px-4 text-mgrey text-start">
        <div
          className="flex items-center"
          onClick={() => {
            setSortBy("types");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span>Types</span>
          <SortDownArrow
            className={`ml-1 transition-transform duration-300 ${
              sortDirection === "asc" && sortBy === "types" ? "rotate-180" : ""
            }`}
          />
        </div>
      </th>
      <th className="p-2 font-Proxima sm:text-sm text-xs font-normal py-4 px-4 text-mgrey text-start">
        Action
      </th>
    </>
  );

  const DataRows = () => (
    <>
      {ServiceReportList?.data?.map((element, index) => (
        <tr
          key={index}
          className="font-Proxima text-[14px] shadow-sm text-mgrey hover:bg-lightprimaryorange"
        >
          <td className="px-4 py-3 lg:text-sm text-xs">
            <div className="flex items-center">
              <input
                type="checkbox"
                className="w-4 h-4 mr-2 accent-themeBtn"
                onChange={(e) => handleRowSelection(element, e.target.checked)}
                checked={selectedRows?.includes(element)}
              />
              {element?.unique_id ?? "-"}
            </div>
          </td>
          <td className="px-2 py-3 lg:text-sm text-xs">
            <div className="truncate-lines-3">
              {element?.outlet_name
                ? element?.outlet_name
                    .toLowerCase()
                    .replace(/\b\w/g, (char) => char.toUpperCase())
                : "-"}
            </div>
          </td>
          <td className="px-2 py-3 lg:text-sm text-xs">
            <div className="truncate-lines-3">
              {element?.outlet_address
                ? element?.outlet_address
                    .toLowerCase()
                    .replace(/\b\w/g, (char) => char.toUpperCase())
                : "-"}
            </div>
          </td>
          <td className="px-5 py-3 lg:text-sm text-xs">{element?.DateTime}</td>
          <td className="px-2 py-3 lg:text-sm text-xs">
            {element?.technician_name && element.technician_name.trim()
              ? element.technician_name
                  .toLowerCase()
                  .replace(/\b\w/g, (char) => char.toUpperCase())
              : "-"}
          </td>
          <td className="px-2 py-3 lg:text-sm text-xs">
            {element?.types || "-"}
          </td>
          <td className="flex px-2 py-3">
            <Action
              optionList={
                <>
                  <li
                    className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                    onClick={() => {
                      setSelectedSaleId([element?.id]);
                      setIsModal(true);
                    }}
                  >
                    View
                  </li>
                  <li
                    className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                    onClick={() => {
                      setSelectedSaleId([element.id]);
                      setIsModal(true);
                    }}
                  >
                    Download
                  </li>
                </>
              }
            />
          </td>
        </tr>
      ))}
    </>
  );

  return (
    <>
      <div>
        <div>
          <h6 className="font-Montserrat font-medium text-xl mb-3">
            Service Report
          </h6>
          <Breadcrumb
            breadCrumbParent={"Home"}
            breadCrumbActive={"Service Report"}
            breadCrumbParent2={"Service Request"}
            breadCrumbTitleKey={"/"}
            classes=""
          />
        </div>
        <div className="flex sm:flex-row flex-col gap-3 items-center sm:space-x-3 mt-8">
          <ReactSelect
            className={"w-full sm:max-w-52 text-black p-0 font-Proxima"}
            id="option"
            placeholder="Bulk Action"
            options={bulkOptions(selectedRows)}
            isClearable={true}
            value={selectedAction}
            isDisabled={selectedRows?.length === 0}
            onChange={(e) => handleBulkAction(e)}
            styles={{
              control: (base) => ({
                ...base,
                border: `1px solid #0000003B`,
                borderColor: selectedAction ? "#F15B29" : "#0000003B",
                borderRadius: "0.3rem",
                boxShadow: "none",
                "&:hover": {
                  border: "1px solid #0000003B",
                },
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isSelected ? "#F15B29" : "white",
                "&:active": {
                  backgroundColor: state.isSelected
                    ? "#F15B29"
                    : "rgba(0, 0, 0, 0.04)",
                },
              }),
            }}
          />
          <ReactSelect
            className="w-full sm:max-w-52 text-black p-0 font-Proxima"
            id="outlet"
            placeholder="Outlet"
            options={outletOptions}
            isClearable={true}
            getOptionValue={(option) => option.value}
            getOptionLabel={(option) => option.label}
            value={outletFilter}
            onChange={(selectedOption) => setOutletFilter(selectedOption)}
            styles={{
              control: (base) => ({
                ...base,
                border: `1px solid #0000003B`,
                borderColor: outletFilter ? "#F15B29" : "#0000003B",
                borderRadius: "0.3rem",
                boxShadow: "none",
                "&:hover": {
                  border: "1px solid #0000003B",
                },
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isSelected ? "#F15B29" : "white",
                "&:active": {
                  backgroundColor: state.isSelected
                    ? "#F15B29"
                    : "rgba(0, 0, 0, 0.04)",
                },
              }),
            }}
          />

          <ReactSelect
            className={"w-full sm:max-w-52 text-black p-0 font-Proxima"}
            id="type"
            placeholder="Types"
            options={Type}
            isClearable={true}
            value={selectedType}
            onChange={(e) => {
              setSelectedType(e);
            }}
            styles={{
              control: (base) => ({
                ...base,
                border: `1px solid #0000003B`,
                borderColor: selectedType ? "#F15B29" : "#0000003B",
                borderRadius: "0.3rem",

                boxShadow: "none",
                "&:hover": {
                  border: "1px solid #0000003B",
                },
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isSelected ? "#F15B29" : "white",
                "& :active": {
                  backgroundColor: state.isSelected
                    ? "#F15B29"
                    : "rgba(0, 0, 0, 0.04)",
                },
              }),
            }}
          />
          <DebounceSearch
            className="sm:full-width"
            search={searchValue}
            handleChange={setSearchValue}
            placeholder={"Search..."}
          />
        </div>
        {ServiceReportListLoading ? (
          <RippleLoader />
        ) : (
          <div className="w-full bg-white shadow rounded-lg mt-5 overflow-x-auto">
            <div className="min-w-[600px]">
              <CustomTable
                columnHeaders={<ColumnHeaders />}
                dataRows={<DataRows />}
                data={ServiceReportList}
                loading={false}
                showPagination={true}
                setPaginationCurrentLimit={setPageLimit}
                paginationCurrentLimit={pageLimit}
                current={pageCount}
                total={ServiceReportList?.total}
                paginationData={(crPage) => setPageCount(crPage)}
                lastPage={Math.ceil(ServiceReportList?.total / pageLimit)}
                overflowVisibleLg={true}
              />
            </div>
          </div>
        )}
      </div>
      {isModal && (
        <div>
          <ViewServiceReport
            onClose={() => {
              setIsModal(false);
            }}
            selectedSaleId={selectedSaleId}
            setIsLoading={setIsLoading}
            isLoading={isLoading}
            showSend={showSend}
            setSelectedAction={setSelectedAction}
            setServiceCount={setServiceCount}
            setSelectedRows={setSelectedRows}
          />
        </div>
      )}
      {showErrorPopup && (
        <div className="model" onClick={() => setShowErrorPopup(false)}>
          <div
            className="bg-white flex flex-col items-center justify-center drop-shadow-lg rounded-lg w-full max-w-md min-h-40 py-8 px-6 mx-auto relative"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="font-Montserrat mb-1 text-center text-primaryBlack font-medium text-xl">
              Cannot send service report to multiple companies. Please only
              select one
            </h2>
            <div className="flex justify-center gap-2 pt-3 w-full">
              <button
                type="button"
                className="text-themeBtn flex items-center uppercase font-Proxima text-[15px] justify-center px-6 py-1.5 rounded border border-themeBtn"
                onClick={() => setShowErrorPopup(false)}
              >
                close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ServiceReport;
